module.exports = __webpack_public_path__ + "img/confeitaria-marques-de-pombal.7cececc8.jpg";